import { IconProps } from '../icon';

export function CrossIcon(props: IconProps) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1479 16.5524C15.2729 15.5351 14.3553 14.5019 13.394 13.4789C10.2425 16.5146 7.32415 19.9328 5.21216 23.7971C2.62131 28.5375 -1.202 24.6584 0.532684 21.2228C1.92713 18.0884 5.51279 13.7398 9.82258 9.96659C7.44907 7.83268 4.84756 5.90848 1.99823 4.49014C-2.17141 2.41403 1.01409 -1.06508 4.03049 0.314904C6.57157 1.32866 10.078 3.93876 13.2859 7.18514C16.4907 4.83948 19.8645 3.00121 22.9063 2.28156C23.5665 2.12504 25.4936 1.70205 25.9375 2.33475C26.1045 2.57361 25.9207 2.93216 25.5779 3.3214C24.4105 4.64921 21.2727 6.75447 19.7523 7.96669C18.6549 8.84183 17.5408 9.75637 16.4328 10.7139C17.6109 12.1874 18.6641 13.7132 19.5035 15.2236C20.2332 16.5361 20.801 17.8373 21.1498 19.0833C21.3093 19.6525 21.7465 21.3154 21.2199 21.7256C21.0213 21.8806 20.7065 21.7338 20.3592 21.4504C19.1739 20.4842 17.2468 17.8306 16.1479 16.5524V16.5524Z"
        fill="#DC1817"
      />
    </svg>
  );
}

export default CrossIcon;
